<template>
    <div :style="{'position': 'relative','height':clientHeight-96-53.2-45.5+'px'}" v-loading="parentInfo.loading" >
        <div class="cacheCanvas" @drop='dropCache($event)' @dragover='allowDropCache($event)' v-if="parentInfo.type=='dayTimeTable'">
            <canvas ref="cachecanvas"
                    slot="cachecanvas"
                    v-on:mousedown="handleCacheMousedown"
                    :width="V4leftTimeW-2" :height="cacheH"
                    :style="{'width':(V4leftTimeW-2)/V4ratio+'px','height':cacheH/V4ratio+'px','border': '4px solid #E0F2DE'}"></canvas>
            <div slot="cachebox" class="scell"
                 style="position: absolute;border: 1px solid #dd6161;width: 100px"
                 v-if='cacheData.selectable'
                 @click="handleCanvaClick($event)"
                 :style="{'left':'8px','top':'15px', 'height':V4rectH/V4ratio+'px'}"
                 :draggable="cacheData.draggable"
            >
            </div>
        </div>

        <div class="timeCanvas" style="height: calc(100% - 100px)" ref="timeScroll">
            <canvas ref="timecanvas"
                    :width="V4leftTimeW+V4ratio*2" :height="row*V4rectH+V4ratio*2"
                    :style="{'width':(V4leftTimeW+V4ratio*2)/V4ratio+'px','height':(row*V4rectH+V4ratio*2)/V4ratio+'px','top':(0-parentInfo.scroll.top+100)+'px'}">
            </canvas>
        </div>

        <div class="teacherCanvas" style="width: calc(100% - 120px)" ref="teacherScroll">
            <canvas ref="teachercanvas"
                    id="teacher"
                    :width="(parentInfo.tempLength+1)*V4titleW+V4ratio*2" :height="2*V4titleH"
                    :style="{'width':(((parentInfo.tempLength+1)*V4titleW+V4ratio*2))/V4ratio+'px','height':(2*V4titleH)/V4ratio+'px','left':(0-scroll.left+120)+'px'}"></canvas>
            <slot name="teacherBox"></slot>
        </div>

        <div style="width: calc(100% + 5px);height: calc(100% + 5px)" class="tableCanvas" @scroll="handleScroll">
            <div style="position: relative">
                <div class="auxiliary">
                    <canvas id="auxiliary" ref="auxiliaryCanvas"
                            :width="(parentInfo.tempLength+1)*V4rectW+V4ratio*2" :height="row*V4rectH+V4ratio*2"
                            :style="{'width':(((parentInfo.tempLength+1)*V4rectW)+V4ratio*2)/V4ratio+'px','height':(row*V4rectH+V4ratio*2)/V4ratio+'px'}"></canvas>
                </div>
                <div class="mainCanvas" ref="viewBox" @drop='drop($event)' @dragover='allowDrop($event)' >
                    <canvas id="timeTable" ref="canvas" v-on:mousedown="handleMousedown"
                            :width="(parentInfo.tempLength+1)*V4rectW+V4ratio*2" :height="row*V4rectH+V4ratio*2"
                            :style="{'width':(((parentInfo.tempLength+1)*V4rectW)+V4ratio*2)/V4ratio+'px','height':(row*V4rectH+V4ratio*2)/V4ratio+'px'}"></canvas>
                    <VueDragResize
                            v-show="cell.visible"
                            :draggable="cell.draggable"
                            class="scell dragging"
                            :x="(cell.rect[0]*V4rectW)/V4ratio"
                            :y="(cell.rect[1]*this.V4rectH)/V4ratio"
                            :isActive="true"
                            :w="V4rectW/V4ratio-2"
                            :h="cell.height-2"
                            axis = "none"
                            :sticks="['tm','bm']"
                            :minh="10"
                            :z="100"
                            :preventActiveBehavior ="true"
                            :isResizable="dragResize"
                            v-on:resizing="resize"
                            v-on:dragging="resize"
                            @clicked="handleCellClick">
                        <div style="text-align: center" :style="{'width':V4rectW/V4ratio-2+'px','height':(cell.height-2)+'px'}">
                            <canvas id="box" ref="boxCanvas"
                                    :width="V4rectW" :height="cell.height*V4ratio"
                                    :style="{'width':V4rectW/V4ratio-2+'px','height':cell.height-2+'px'}"></canvas>
                        </div>
                    </VueDragResize>

                    <div class="timeCell"
                         :style="{'left':(dropCell.timeRect[0]+10)/V4ratio+'px','top':(dropCell.timeRect[1])/V4ratio+'px'}"
                         v-if="dropCell.dropClick">
                        {{dropCell.time}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VueDragResize from 'vue-drag-resize'
    export default {
        name: 'v4Table',
        data() {
            return {
                draggable:false,
                borderColor: '#ededed',
                fillStyle: "#555",

                V4titleW: 100 * window.devicePixelRatio,
                V4titleH: 50 * window.devicePixelRatio,
                V4leftTimeW: 120 * window.devicePixelRatio,
                V4rectW: 100 * window.devicePixelRatio,
                V4rectH: 200 * window.devicePixelRatio,
                V4ratio: window.devicePixelRatio,
                cacheH: 90 * window.devicePixelRatio,
                V4divi: 8,
                scroll: {
                    x: 0,
                    y: 0
                },
                startPoint: {
                    x: 1,
                    y: 1
                },
                cell: {
                    rect: [0, 0, 0, 0],
                    subject_id: 0,
                    teacher_id: 0,
                    template_time_id: 0,
                    name: '',
                    classroom_name: '',
                    time: '',
                    color: '',
                    background_color:'transparent',
                    classPlan_id: '',
                    classHeight: 1,
                    draggable: false,
                    visible: false,
                    contentVisible: false,
                    chooseOn: false,
                    height:90,
                    section_id:'',
                },
                cacheData: {
                    rect: [],
                    subject_id: '',
                    teacher_id: '',
                    classPlan_id: '',
                    class_name: '',
                    class_id: '',
                    classHeight: 1,
                    classroom_name: '',
                    classroom_id: '',
                    remark: '',
                    selectable: false,
                    draggable: false,
                    chooseOn: false,
                    section_id:'',
                },
                auxiliaryLine: 6,
                startTime: 8,
                endTime: 23,
                dropCell: {
                    originRect: [0, 0],
                    originClick: false,
                    dropClick: false,
                    timeRect: [0, 0],
                },
                width: 0,
                height: 60,
                top: 0,
                dragResize:false,
                canvas:'',
                auxiliaryCanvas:'',
                teachercanvas:'',
                timecanvas:'',
                cachecanvas:'',
            }
        },
        created() {
            this.startPoint = {
                x: this.V4ratio,
                y: this.V4ratio
            };
            this.parentInfo = this.$parent;
            if(this.parentInfo.type=='dayTimeTable'){
                this.draggable=true;
            }
            this.$nextTick(() => {
                this.initCanvas();
            });
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            list() {
                let length = 0;
                for (let subject_id in this.parentInfo.subjects) {
                    if(this.parentInfo.subjects[subject_id].view) {
                        if (this.parentInfo.teachers[subject_id]) {
                            length += this.parentInfo.subjects[subject_id].dataLength
                        }
                    }
                }
                return length;
            },
            row() {
                let length = 0;
                for (const key in this.parentInfo.basisTime) {
                    if (key > this.parentInfo.startTime && key < this.endTime) {
                        length++;
                    }
                }
                return length
            }
        },
        mounted(){
            this.canvas=this.$refs.canvas;
            this.auxiliaryCanvas=this.$refs.auxiliaryCanvas;
            this.teachercanvas=this.$refs.teachercanvas;
            this.timecanvas=this.$refs.timecanvas;
            this.cachecanvas=this.$refs.cachecanvas;

        },
        components: {
            VueDragResize,
        },
        methods: {
            resize(newRect) {
                this.cell.height = newRect.height;
                this.top = newRect.top;
                this.cell.rect[1] = newRect.top * this.V4ratio / this.V4rectH;
                this.cell.classHeight = newRect.height / this.V4rectH * this.V4ratio;
                this.dropCell.timeRect = [newRect.left, newRect.top];
                this.dropCell.time = (parseInt(this.cell.rect[1]) + this.parentInfo.startTime) + ':' + ((Math.round(((this.cell.rect[1] - parseInt(this.cell.rect[1])) * 6)) * 10) == 0 ? '00' : Math.round(((this.cell.rect[1] - parseInt(this.cell.rect[1])) * 6)) * 10);
                this.dropCell.dropClick = true;
            },
            //开画
            drawLine(ctx, start = [0, 0], end = [0, 0], lineDash = []) {
                let x = this.startPoint.x;
                let y = this.startPoint.y;
                ctx.beginPath();
                ctx.setLineDash(lineDash);
                ctx.moveTo(start[0] + x, start[1] + y);
                ctx.lineTo(end[0] + x, end[1] + y);
                ctx.stroke()
            },
            drawRect(ctx, x, y, width, height) {
                ctx.fillRect(x + this.startPoint.x, y + this.startPoint.y, width, height);
            },
            drawText(ctx, text, x, y) {
                ctx.fillText(text, x + this.startPoint.x, y + this.startPoint.y);
            },
            initCanvas() {
                this.clearCanvas();
                this.paintTables();
                this.paintTime();
            },
            clearCanvas(){
                const teacherCanvas = this.teachercanvas;
                let ctx = teacherCanvas.getContext('2d');
                ctx.clearRect(0, this.V4titleH, (this.parentInfo.tempLength+1)*this.V4titleW+this.V4ratio*2,
                    2 * this.V4titleH);

                const canvas = this.canvas;
                let cctx = canvas.getContext('2d');
                cctx.clearRect(0, 0, (this.parentInfo.tempLength+1)*this.V4rectW+this.V4ratio*2,
                    this.row * this.V4rectH);
            },
            getFontStyle(size, lineHeight) {
                return 'normal ' + size * this.V4ratio + 'px/' + lineHeight * this.V4ratio + 'px  Microsoft YaHei';
            },
            paintLine() {
                const classCanvas = this.canvas;
                let ctx = classCanvas.getContext('2d');
                ctx.beginPath();
                //课表竖线
                ctx.lineWidth = 2 * this.V4ratio;
                ctx.strokeStyle = "#000";
                this.drawLine(ctx, [0, 0], [0, this.V4rectH * this.row], []);
                this.drawLine(ctx, [10, 0], [10, this.V4rectH * this.row], []);
                this.drawLine(ctx, [20, 0], [20, this.V4rectH * this.row], []);

                this.drawLine(ctx, [0, 0], [1000, 0], []);
                this.drawLine(ctx, [0, 10], [1000, 10], []);
                this.drawLine(ctx, [0, 20], [1000, 20], []);

                ctx.stroke()
            },
            paintCache() {
                const cachecanvas = this.cachecanvas;
                let ctxc = cachecanvas.getContext('2d');
                ctxc.clearRect(0, 0, this.V4leftTimeW - 10, this.cacheH);
                ctxc.lineWidth = 2 * this.V4ratio;
                ctxc.font = this.getFontStyle(12, 12);
                ctxc.fillStyle = '#555';
                ctxc.textAlign = "center";
                ctxc.textBaseline = "middle";
                this.drawText(ctxc, this.cacheData.class_name, (this.V4leftTimeW - 2) / 2, (this.cacheH / 2) / this.V4ratio);
                ctxc.stroke()
            },
            //画时间
            paintTime() {
                const timecanvas = this.timecanvas;
                let ctx = timecanvas.getContext('2d');

                ctx.clearRect(0, 0, this.V4leftTimeW, this.row * this.V4rectH);

                ctx.lineWidth = 1 * this.V4ratio;

                ctx.font = this.getFontStyle(12, 12);

                ctx.fillStyle = this.fillStyle;

                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                for (const key in this.parentInfo.timeData) {
                    for (let j = 0; j < 2; j++) {
                        ctx.fillText(
                            this.parentInfo.timeData[key].content[j],
                            this.V4leftTimeW / 4,
                            (this.parentInfo.timeData[key].sort[j] - this.parentInfo.startTime) * this.V4rectH + this.V4rectH / 20
                        );
                        this.drawLine(ctx, [this.V4leftTimeW / 2, (this.parentInfo.timeData[key].sort[j] - this.parentInfo.startTime) * this.V4rectH], [this.V4leftTimeW, (this.parentInfo.timeData[key].sort[j] - this.parentInfo.startTime) * this.V4rectH]);
                    }
                }

                const auxiliaryCanvas = this.auxiliaryCanvas;
                let actx = auxiliaryCanvas.getContext('2d');
                actx.lineWidth = 2 * this.V4ratio;

                let i = 0;
                for (const key in this.parentInfo.basisTime) {
                    if (key > this.parentInfo.startTime && key < this.endTime) {
                        ctx.fillText(
                            this.parentInfo.basisTime[key].content,
                            4 * this.V4leftTimeW / 5,
                            i * this.V4rectH + this.V4rectH / 20
                        );
                        //辅助线
                        actx.beginPath();
                        for (let key in this.parentInfo.subjects) {
                            if(this.parentInfo.subjects[key].view) {
                                let subject = this.parentInfo.subjects[key];
                                actx.strokeStyle = subject.color;
                                this.drawLine(actx, [subject.rect[0] * this.V4titleW, i * this.V4rectH], [subject.rect[0] * this.V4titleW + subject.rect[2] * this.V4titleW, i * this.V4rectH], []);
                                for (let j = 1; j < this.auxiliaryLine; j++) {
                                    this.drawLine(actx, [subject.rect[0] * this.V4titleW, this.V4rectH * i + (this.V4rectH * (j / this.auxiliaryLine))], [subject.rect[0] * this.V4titleW + subject.rect[2] * this.V4titleW, this.V4rectH * i + (this.V4rectH * (j / this.auxiliaryLine))], [5]);
                                }
                            }

                        }
                        actx.stroke()

                        i++;
                    }
                }

                //课表科目之间竖实线
                for (let key in this.parentInfo.subjects) {
                    if(this.parentInfo.subjects[key].view) {
                        let subject = this.parentInfo.subjects[key];
                        for (let i = 0; i < subject.rect[2] + 1; i++) {
                            this.drawLine(actx, [this.V4rectW * (i + subject.rect[0]), 0], [this.V4rectW * (i + subject.rect[0]), this.V4rectH * this.row]);
                        }
                    }
                }

                ctx.strokeStyle = this.borderColor;
                this.drawLine(ctx, [this.V4leftTimeW, 0], [this.V4leftTimeW, this.V4rectH * this.row], []);

                //课表竖线
                for (let i = 0; i < 2; i++) {
                    this.drawLine(ctx, [this.V4leftTimeW / 2 * i, 0], [this.V4leftTimeW / 2 * i, this.V4rectH * this.row], []);
                }

                ctx.stroke()
            },

            //画表
            paintTables() {
                const canvas = this.canvas;
                let ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, (this.list + 1) * this.V4rectW, this.row * this.V4rectH);
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                for (let key in this.parentInfo.subjects) {
                    if(this.parentInfo.subjects[key].view) {
                        let subject = this.parentInfo.subjects[key];
                        this.paintSubjects(subject);
                        let teachers = this._.orderBy(this.parentInfo.teachers[key], 'sortBy', 'asc');
                        let co = 1;
                        let i = 0;
                        for (const teacher_id in teachers) {
                            let teacher = teachers[teacher_id];
                            if(teacher.view){
                                co++;
                                this.paintClass(teacher, i, subject);
                                this.paintTeachers(teacher, i, subject, co);
                                i++
                            }
                        }
                    }
                }
            },
            //画学科
            paintSubjects(subject) {
                const subjectCanvas = this.teachercanvas;
                let ctx = subjectCanvas.getContext('2d');
                ctx.globalAlpha = 1;
                ctx.clearRect(subject.rect[0] * this.V4titleW, subject.rect[1] * this.V4titleH, this.V4titleW, this.V4titleH);
                ctx.fillStyle = subject.color;
                this.drawRect(ctx, subject.rect[0] * this.V4titleW, subject.rect[1] * this.V4titleH, subject.rect[2] * this.V4titleW, this.V4titleH);
                ctx.fillStyle = 'rgba(0,0,0,0.5)';
                ctx.font = 'bold ' + 15 * this.V4ratio + 'px/' + 15 * this.V4ratio + 'px  Microsoft YaHei';
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                this.drawText(ctx,
                    subject.name,
                    subject.rect[0] * this.V4titleW + subject.rect[2] * this.V4titleW / 2,
                    subject.rect[1] * this.V4titleH + subject.rect[3] * this.V4titleH / 2
                )

            },
            //画老师
            paintTeachers(teacher, i, subject, co) {
                const teacherCanvas = this.teachercanvas;
                let ctx = teacherCanvas.getContext('2d');
                ctx.clearRect((subject.rect[0] + i) * this.V4titleW, this.V4titleH, this.V4titleW, this.V4titleH);

                ctx.beginPath();
                ctx.fillStyle = subject.color;
                ctx.globalAlpha = 0.4;
                ctx.fillRect((subject.rect[0] + i) * this.V4titleW, this.V4titleH, this.V4titleW, this.V4titleH);
                ctx.globalAlpha = 1;

                ctx.fillStyle = '#555';
                ctx.font = 'normal ' + 12 * this.V4ratio + 'px/' + 25 * this.V4ratio + 'px  Microsoft YaHei';

                ctx.textAlign = "center";
                ctx.textBaseline = "middle";

                let teacher_name= teacher.name;
                if(this.parentInfo.showCheck){
                    if(this.parentInfo.teacher_finished_students[teacher.teacher_id]){
                        teacher_name=teacher_name+'-'+this.parentInfo.teacher_finished_students[teacher.teacher_id].length
                    }else{
                        teacher_name=teacher_name+'-0';
                    }
                }

                //老师名
                this.drawText(ctx,
                    teacher_name,
                    (subject.rect[0] + i) * this.V4titleW + this.V4titleW / 2,
                    this.V4titleH + this.V4titleH / 4);
                //老师备注
                this.drawText(ctx,
                    teacher.note ? teacher.note : '无',
                    (subject.rect[0] + i) * this.V4titleW + this.V4titleW / 2,
                    this.V4titleH + this.V4titleH * 3 / 4);

                if (co != 1) {
                    ctx.lineWidth = 2 * this.V4ratio;
                    ctx.strokeStyle = subject.color;
                    this.drawLine(ctx, [(subject.rect[0] + i) * this.V4titleW, this.V4titleH], [(subject.rect[0] + i) * this.V4titleW, this.V4titleH * 2], []);
                    this.drawLine(ctx, [(subject.rect[0] + i + 1) * this.V4titleW, this.V4titleH], [(subject.rect[0] + i + 1) * this.V4titleW, this.V4titleH * 2], []);
                }

                ctx.stroke()
            },
            //画班级
            paintClass(teacher, i, subject) {
                let classes = this.parentInfo.classes[teacher.teacher_id];
                const classCanvas = this.canvas;
                let ctx = classCanvas.getContext('2d');
                //let circle = classCanvas.getContext('2d');

                ctx.beginPath();
                ctx.lineWidth = 1 * this.V4ratio;
                ctx.strokeStyle = '#696969';
                for (const key in this.parentInfo.timeData) {
                    for (let j = 0; j < 2; j++) {
                        this.drawLine(ctx,
                            [subject.rect[0] * this.V4titleW, (this.parentInfo.timeData[key].sort[j] - this.parentInfo.startTime) * this.V4rectH],
                            [subject.rect[0] * this.V4titleW + subject.rect[2] * this.V4titleW, (this.parentInfo.timeData[key].sort[j] - this.parentInfo.startTime) * this.V4rectH]);
                    }
                }

                ctx.stroke()

                ctx.beginPath();
                ctx.lineWidth = 2 * this.V4ratio;
                ctx.font = this.getFontStyle(12, 15);
                ctx.fillStyle = '#555';
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                let color = '#555';
                for (let class_id in classes) {
                    let classx = classes[class_id];

                    var classHeight = classx.end_sort - classx.start_sort;

                    if (this.parentInfo.filter.grade_id.length !== 0) {
                        if (this.parentInfo.filter.grade_id.includes(classx.grade_id)) {
                            ctx.fillStyle = classx.color;
                            color = classx.color;
                        } else {
                            ctx.fillStyle = '#ededed';
                            color = '#ededed';
                        }
                    } else {
                        if (![3, 6].includes(classx.class_type_id)) {
                            ctx.fillStyle = '#FF0000';
                            color = '#FF0000';
                        } else {
                            ctx.fillStyle = classx.color;
                            color = classx.color;
                        }
                    }

                    if (this.parentInfo.type == 'dayTimeTable_cart') {
                        if (![4, 5].includes(classx.type)) {
                            ctx.fillStyle = '#ededed';
                            color = '#ededed';
                        }
                    }

                    if (this.parentInfo.filter.section_id != classx.section_id) {
                        ctx.fillStyle = '#D3D3D3';
                        color = '#D3D3D3';
                    }


                    ctx.globalAlpha = 0.05;
                    ctx.fillRect((subject.rect[0] + i) * this.V4rectW, (classx.start_sort - this.parentInfo.startTime) * this.V4rectH,
                        this.V4rectW, classHeight * this.V4rectH);
                    ctx.globalAlpha = 1;

                    for (let d = 0; d < 1; d++) {
                        //班级名
                        this.drawText(ctx, classx.class.slice(d * 8, 8 + d * 9),
                            (subject.rect[0] + i) * this.V4rectW + this.V4rectW / 2,
                            (classx.start_sort - this.parentInfo.startTime) * this.V4rectH + this.V4rectH / this.V4divi * ((d ? 3 : 3) / 4));

                        if (d === 1)
                            break;
                        //教室名
                        var secondName = classx.classroom_name ? classx.classroom_name.slice(4, 20) : '无'
                        if (this.parentInfo.filter.section_id != classx.section_id) {
                            secondName = classx.section_name
                        }
                        this.drawText(ctx, secondName,
                            (subject.rect[0] + i) * this.V4rectW + this.V4rectW / 2,
                            (classx.start_sort - this.parentInfo.startTime) * this.V4rectH +  this.V4rectH / this.V4divi * ((d ? 3 : 3) / 4) + 20 * window.devicePixelRatio)
                    }

                    //班级学生姓名
                    if (this.parentInfo.class_student[classx.class_plan_id]) {
                        if (this.parentInfo.showStudent && this.parentInfo.class_student[classx.class_plan_id].length > 0) {
                            let row = 5;
                            let a = 0;
                            let b = 2;
                            for (let student of this.parentInfo.class_student[classx.class_plan_id]) {
                                let drawStudent = true;
                                if (this.parentInfo.type === 'dayTimeTable') {
                                    if (student.classPlan_id !== classx.class_plan_id) {
                                        drawStudent = false;
                                    }
                                    if (student.status === 'active') {
                                        color = 'grey';
                                    } else if (student.status === 'cancel') {
                                        color = "#898989";
                                    } else if (student.status === 'leaving') {
                                        color = 'rgba(133,214,225,1)';
                                    } else if (student.status === 'absent') {
                                        color = "#946767";
                                    } else if (student.status === 'switching') {
                                        color = "#81AEE4";
                                    } else if (student.status === 'refund') {
                                        color = "#F5A77C";
                                    } else if (student.status === 'finished') {
                                        color = "rgb(51,128,109)";
                                    } else if (student.status === 'truancy') {
                                        color = "#E77E7E";
                                    } else if (student.status === 'trying') {
                                        color = "rgba(204,204,0,1)";
                                    }

                                }
                                ctx.fillStyle = color;

                                if (drawStudent) {
                                    ctx.fillText(student.student_name.substr(0, 4),
                                        (subject.rect[0] + i) * this.V4rectW + this.V4rectW / this.V4divi * (row % 2 === 0 ? 6 : 2),
                                        (classx.start_sort - this.parentInfo.startTime) * this.V4rectH +  this.V4rectH / this.V4divi / 3 * (row % 2 === 0 ? row - 2 : row - 1) +  (30+(b-1)*5)  * window.devicePixelRatio);

                                    student.rect = [a, b, 1, 1];
                                    a++;
                                    if (a > 1) {
                                        b++;
                                        a = 0;
                                    }
                                    row++
                                }
                            }
                        }


                    }

                }
                ctx.stroke();


            },

            //滚轮滚动
            handleScroll(e) {
                this.$refs.teacherScroll.scrollLeft = e.target.scrollLeft;
                this.$refs.timeScroll.scrollTop = e.target.scrollTop;
                this.$emit('cartScroll', e.target.scrollTop)
                this.cell.visible=false;
            },
            getPara(inx, iny) {
                const x = inx * this.V4ratio;
                const y = iny * this.V4ratio;
                const px = Math.floor(x / this.V4rectW);
                const py = parseFloat((y / this.V4rectH).toFixed(1));

                //寻找subject_id
                let subject_id = 0;
                for (let key in this.parentInfo.subjects) {
                    if(this.parentInfo.subjects[key].view) {
                        if (this.parentInfo.subjects[key].rect[0] * this.V4rectW < x && x < (this.parentInfo.subjects[key].rect[2] + this.parentInfo.subjects[key].rect[0]) * this.V4rectW) {
                            subject_id = key;
                            break;
                        }
                    }
                }

                //寻找老师id
                let teacher_id = 0;
                let subject = this.parentInfo.subjects[subject_id];
                let teachers = this._.orderBy(this.parentInfo.teachers[subject_id], 'sortBy', 'asc');

                let j = 0;
                let nx = 0;
                for (const key in teachers) {
                    if(teachers[key].view){
                        if ((subject.rect[0] + j) * this.V4rectW < x && x < (subject.rect[0] + j + 1) * this.V4rectW) {
                            nx = subject.rect[0] + j;
                            teacher_id = teachers[key].teacher_id;
                            break;
                        }
                        j++;
                    }
                }
                return {
                    subject_id: subject_id,
                    teacher_id: teacher_id,
                    rect: [nx, py, 1, 1],
                }
            },

            handleMousedown(evt) {
                if (evt.button===1){
                    this.cell.visible=false;
                    return;
                }

                this.dropCell = {
                    originRect: [0, 0],
                    originClick: false,
                    dropClick: false,
                    timeRect: [0, 0],
                };
                this.cacheData.draggable = false;
                this.cacheData.selectable = false;
                let {subject_id, teacher_id, rect} = this.getPara(evt.offsetX, evt.offsetY);

                this.cell = {
                    rect: rect,
                    subject_id: subject_id,
                    teacher_id: teacher_id,
                    name: '',
                    draggable: false,
                    visible: true,
                    contentVisible: false,
                    classHeight: 1,
                    classroom_name: '',
                    classPlan_id: '',
                    classroom_id: '',
                    remark: '',
                    section_id: '',
                    background_color: 'transparent',
                    height: this.V4rectH / this.V4ratio
                };

                let data = {
                    'type': 'blank',
                    'subject_id': subject_id,
                    'teacher_id': teacher_id,
                    'startSort': 0,
                    'classx': ''
                };
                if (this.parentInfo.classes[teacher_id]) {
                    for (var key in this.parentInfo.classes[teacher_id]) {
                        let startSort = this.parentInfo.classes[teacher_id][key].start_sort - this.parentInfo.startTime
                        let endSort = this.parentInfo.classes[teacher_id][key].end_sort - this.parentInfo.startTime
                        if (rect[1] > startSort && rect[1] < endSort) {
                            let classx = this.parentInfo.classes[teacher_id][key];
                            data.type = 'class';
                            this.cell.name = classx.class.slice(0, 8);
                            this.cell.classPlan_id = classx.class_plan_id;
                            this.cell.color = classx.color;
                            this.cell.classroom_id = classx.classroom_id;
                            this.cell.remark = classx.remark;
                            this.cell.section_id = classx.section_id;
                            if (this.parentInfo.filter.grade_id.length !== 0) {
                                if (this.parentInfo.filter.grade_id.includes(classx.grade_id)) {
                                    this.cell.color = classx.color;
                                } else {
                                    this.cell.color = '#ededed';
                                }
                            } else {
                                if (![3, 6].includes(classx.class_type_id)) {
                                    this.cell.color = '#FF0000';
                                } else {
                                    this.cell.color = classx.color;
                                }
                            }

                            data.startSort = startSort;
                            this.cell.rect[1] = startSort;
                            this.cell.classHeight = endSort - startSort;
                            this.cell.classroom_name = classx.classroom_name ? classx.classroom_name.slice(4, 20) : '无';
                            this.cell.time = (parseInt(startSort) + this.parentInfo.startTime) + ':' + (((startSort - parseInt(startSort)) * 60).toPrecision(2) == 0 ? "00" : ((startSort - parseInt(startSort)) * 60).toPrecision(2));
                            if(this.parentInfo.type=='dayTimeTable'){
                                this.cell.draggable = true;
                            }

                            this.dragResize = false;
                            this.cell.height = (endSort - startSort) * this.V4rectH / this.V4ratio;
                            this.cell.background_color = 'white';
                            this.paintBoxCanvas(classx, this.cell.classHeight);
                            break;
                        }
                    }
                }

                if (data.type == 'blank') {
                    for (const key in this.parentInfo.timeData) {
                        if(this.parentInfo.timeData[key].sort[1]-this.parentInfo.timeData[key].sort[0]<2.5){
                            if (rect[1] > this.parentInfo.timeData[key].sort[0] - this.parentInfo.startTime && rect[1] < this.parentInfo.timeData[key].sort[1] - this.parentInfo.startTime) {
                                this.cell.rect[1] = this.parentInfo.timeData[key].sort[0] - this.parentInfo.startTime;
                                this.cell.classHeight = this.parentInfo.timeData[key].sort[1] - this.parentInfo.timeData[key].sort[0];
                                this.cell.height = (this.parentInfo.timeData[key].sort[1] - this.parentInfo.timeData[key].sort[0]) * this.V4rectH / this.V4ratio
                                break;
                            }
                        }
                    }
                    if (this.parentInfo.type != 'dayTimeTable') {
                        this.dragResize = true;
                    }
                    this.paintBoxCanvas('', this.cell.classHeight);
                }
                return this.$emit('handleMouseDown', data);
            },
            paintBoxCanvas(classx, classHeight) {

                const boxCanvas = this.$refs.boxCanvas;
                let ctx = boxCanvas.getContext('2d');

                ctx.clearRect(0, 0, this.V4rectW, classHeight * this.V4rectH);
                if (classx) {
                    ctx.beginPath();
                    ctx.lineWidth = 2 * this.V4ratio;
                    ctx.font = this.getFontStyle(12, 10);
                    ctx.fillStyle = '#555';
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    var color = '#555';

                    if (this.parentInfo.filter.grade_id.length !== 0) {
                        if (this.parentInfo.filter.grade_id.includes(classx.grade_id)) {
                            ctx.fillStyle = classx.color;
                            color = classx.color;
                        } else {
                            ctx.fillStyle = '#ededed';
                            color = '#ededed';
                        }
                    } else {
                        if (![3, 6].includes(classx.class_type_id)) {
                            ctx.fillStyle = '#FF0000';
                            color = '#FF0000';
                        } else {
                            ctx.fillStyle = classx.color;
                            color = classx.color;
                        }
                    }

                    if (this.parentInfo.type == 'dayTimeTable_cart') {
                        if (![4, 5].includes(classx.type)) {
                            ctx.fillStyle = '#ededed';
                            color = '#ededed';
                        }
                    }

                    ctx.globalAlpha = 0.05;
                    ctx.fillRect(0, 0, this.V4rectW, classHeight * this.V4rectH);
                    ctx.globalAlpha = 1;

                    for (let d = 0; d < 1; d++) {
                        //班级名
                        this.drawText(ctx, classx.class.slice(d * 8, 8 + d * 9), this.V4rectW / 2 -  window.devicePixelRatio,  this.V4rectH / this.V4divi * ((d ? 3 : 3) / 4) - window.devicePixelRatio);

                        if (d === 1)
                            break;
                        //教室名
                        var secondName = classx.classroom_name ? classx.classroom_name.slice(4, 20) : '无'
                        if (this.parentInfo.filter.section_id != classx.section_id) {
                            secondName = classx.section_name
                        }
                        this.drawText(ctx, secondName, this.V4rectW / 2 -  window.devicePixelRatio,
                             this.V4rectH / this.V4divi * ((d ? 3 : 3) / 4) + 19 * window.devicePixelRatio)
                    }

                    ctx.stroke();
                }
            },
            handleCacheMousedown(evt) {
                this.cell.visible = false;
                this.cell.draggable = false;

                this.cacheData.selectable = true;
                this.cacheData.draggable = true;
            },
            handleCellClick(evt) {
                const x = evt.offsetX * this.V4ratio;
                const y = evt.offsetY * this.V4ratio;

                const offsetX = x - (Math.floor(x / this.V4rectW)) * this.V4rectW;
                const offsetY = y - (Math.floor(y / (this.V4rectH*this.cell.classHeight))) * (this.V4rectH*this.cell.classHeight);
                if(this.cell.section_id!=this.parentInfo.filter.section_id){
                    return this.$message({
                        message: '校区不同',
                        type: 'warning'
                    });
                }
                if (this.parentInfo.showStudent && offsetY > 40) {

                    let x = offsetX;
                    let y = offsetY;
                    let px = (Math.floor(x / 50) / 2 === 0) ? 0 : 1;
                    //let py = Math.floor(Math.round(y/10)*10 / (this.V4rectH / this.V4ratio / this.V4divi + 5 * window.devicePixelRatio));
                    let py = Math.round(Math.round(Math.round((y-(this.V4rectH / this.V4divi / 3 * 3 + 30 * window.devicePixelRatio))/((this.V4rectH / this.V4divi / 3+window.devicePixelRatio)/this.V4ratio))/2)+1);
                    if(py>6){
                        py=py-1;
                    }
                    let rect = [px, py, 1, 1];
                    for (const student_id in this.parentInfo.class_student[this.cell.classPlan_id]) {
                        let student_rect = this.parentInfo.class_student[this.cell.classPlan_id][student_id].rect;
                        if (rect.sort().toString() === student_rect.sort().toString()) {
                            let student = this.parentInfo.class_student[this.cell.classPlan_id][student_id];
                            let status_name='';
                            if(student.status=='active'){
                                status_name='未上';
                            }else if(student.status=='finished'){
                                status_name='签到';
                            }
                            else if(student.status=='absent'){
                                status_name='缺席';
                            }
                            else if(student.status=='leaving'){
                                status_name='请假';
                            }
                            else if(student.status=='truancy'){
                                status_name='旷课';
                            }
                            else if(student.status=='trying'){
                                status_name='试听';
                            }
                            else if(student.status=='applyForRefund'){
                                status_name='退费申请';
                            }
                            else if(student.status=='applyForLeave'){
                                status_name='请假申请';
                            }
                            this.$Win.openModal('Dialog_SignLogDaily', 341, 200, student.student_name+'-'+status_name,{
                                'classPlanStudent_id':student.classPlan_student_id,
                                'student_id':student.student_id,
                                'status':student.status,
                                'type':student.type});
                        }
                    }

                    this.cell.draggable = false;
                    this.cell.chooseOn = false;
                    this.cell.visible = false;
                }
                else {
                    var data = {
                        'classHeight': this.cell.classHeight,
                        'start_time': (parseInt(this.cell.rect[1]) + this.parentInfo.startTime) + ':' + ((Math.round(((this.cell.rect[1] - parseInt(this.cell.rect[1])) * 6)) * 10) == 0 ? '00' : Math.round(((this.cell.rect[1] - parseInt(this.cell.rect[1])) * 6)) * 10)
                    };
                    return this.$emit('handleCellClick', data);
                }

            },
            handleCanvaClick() {
                this.cacheData.selectable = true;
            },
            drop(evt) {
                this.dropCell.originRect = [0, 0];
                this.dropCell.dropClick = false;
                this.dropCell.originClick = false;
                let {subject_id, teacher_id, rect} = this.getPara(evt.offsetX, evt.offsetY);

                let clickJudge=false;
                if(this.parentInfo.filter.section_id==4){
                    if(this.parentInfo.powers.includes(144)){
                        clickJudge=true;
                    }
                }else{
                    if(this.parentInfo.powers.includes(30)){
                        clickJudge=true;
                    }
                }

                if (clickJudge) {
                    evt.preventDefault();

                    let originData = {
                        rect: '',
                        subject_id: '',
                        teacher_id: '',
                        classPlan_id: '',
                        class_name: '',
                        classHeight: 1,
                        classroom_name: '',
                        classroom_id: '',
                        remark: '',
                    };
                    if (this.cell.chooseOn) {
                        originData = this.cell;
                        originData.type = 'table';
                    } else if (this.cacheData.chooseOn) {
                        originData = this.cacheData;
                        originData.type = 'cache';
                    } else {
                        return this.$message({
                            message: '未选中班级',
                            type: 'warning'
                        });
                    }

                    let data = {
                        'type': 'blank',
                        'subject_id': subject_id,
                        'teacher_id': teacher_id,
                        'startSort': 0,
                        'time': this.dropCell.time
                    };

                    if (originData.subject_id != subject_id) {
                        return this.$message({
                            message: '学科不同',
                            type: 'warning'
                        });
                    }

                    if (originData.section_id != this.parentInfo.filter.section_id) {
                        return this.$message({
                            message: '校区不同，不能调动',
                            type: 'warning'
                        });
                    }

                    if (this.parentInfo.classes[teacher_id]) {
                        for (var key in this.parentInfo.classes[teacher_id]) {
                            let startSort = this.parentInfo.classes[teacher_id][key].start_sort - this.parentInfo.startTime
                            let endSort = this.parentInfo.classes[teacher_id][key].end_sort - this.parentInfo.startTime
                            if (this.parentInfo.classes[teacher_id][key].class_plan_id != originData.classPlan_id) {
                                if (rect[1] >= startSort && rect[1] <= endSort) {
                                    return this.$message({
                                        message: '不能重叠',
                                        type: 'warning'
                                    });
                                }
                            }
                        }
                    }

                    this.cacheData.chooseOn = false;
                    this.cell.chooseOn = false;
                    this.$confirm('确认调换?', '提示', {
                        StartReturn: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        return this.$emit('drop', {
                            'origin': originData,
                            'next': data,
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                }
            },
            allowDrop: function (event) {
                this.cell.visible = false;
                this.cacheData.selectable = false;
                if (!this.cacheData.chooseOn) {
                    this.cell.chooseOn = true;
                }
                let x = event.offsetX * this.V4ratio;
                let y = event.offsetY * this.V4ratio;

                if (!this.dropCell.originClick) {
                    this.dropCell.originRect = [x, y]
                    this.dropCell.originClick = true;
                } else if (x >= 0 && y >= 0) {
                    this.dropCell.dropClick = true;
                    x = x - this.dropCell.originRect[0];
                    y = y - this.dropCell.originRect[1];
                } else {
                    this.dropCell.dropClick = false;
                    this.dropCell.originRect = [0, 0];
                }
                const py = parseFloat((y / this.V4rectH).toFixed(1));
                this.dropCell.timeRect = [x, y];
                this.dropCell.time = (parseInt(py) + this.parentInfo.startTime) + ':'
                    + ((Math.round(((py - parseInt(py)) * 6)) * 10) == 0 ? '00' : Math.round(((py - parseInt(py)) * 6)) * 10);
                return this.$emit('allowDrop', event);
            },
            dropCache: function (evt) {
                this.dropCell.originRect = [0, 0];
                this.dropCell.dropClick = false;
                this.dropCell.originClick = false;

                let clickJudge=false;
                if(this.parentInfo.filter.section_id==4){
                    if(this.parentInfo.powers.includes(144)){
                        clickJudge=true;
                    }
                }else{
                    if(this.parentInfo.powers.includes(30)){
                        clickJudge=true;
                    }
                }
                if (clickJudge) {
                    let state = {
                        selectable: false,
                        rect: '',
                        subject_id: '',
                        teacher_id: '',
                        classPlan_id: '',
                        class_name: '',
                        classHeight: 1,
                        classroom_name: '',
                        classroom_id: '',
                        remark: '',
                        section_id: '',
                    };
                    this.cacheData = state;
                    evt.preventDefault();
                    if (this.cell.draggable === false)
                        return false;

                    let newState = {
                        selectable: this.cell.visible,
                        rect: this.cell.rect,
                        subject_id: this.cell.subject_id,
                        teacher_id: this.cell.teacher_id,
                        classPlan_id: this.cell.classPlan_id,
                        class_name: this.cell.name,
                        classHeight: this.cell.classHeight,
                        classroom_name: this.cell.classroom_name,
                        classroom_id: this.cell.classroom_id,
                        remark: this.cell.remark,
                        section_id: this.cell.section_id,
                    };
                    this.cacheData = newState;
                    this.paintCache();
                    this.cell.visible = false;
                }
                this.cacheData.chooseOn = false;
                this.cell.chooseOn = false;
            },
            allowDropCache: function (event) {
                this.cacheData.selectable = false;
                this.cacheData.chooseOn = true;
                let x = event.offsetX * this.V4ratio;
                let y = event.offsetY * this.V4ratio;
                if (!this.dropCell.originClick) {
                    this.dropCell.originRect = [x, y]
                    this.dropCell.originClick = true;
                }
                event.preventDefault();
                return true;
            },
        },
        beforeDestroy() {

        }
    }
</script>
<style scoped lang="scss">
    $border-color: #ededed;
    .canvas-border {
        border: 2px solid $border-color;
    }

    .timeCanvas {
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
        canvas {
            background: #fff;
        }
        z-index: 10;
        background: #fff;
        position: absolute;
        top: 100px;
        overflow: auto;
        .item {
            &:last-of-type {
                border-bottom: 1px solid #555;
            }
            height: 50px;
            border-top: 1px solid #555;
            border-left: 1px solid #555;
            border-right: 1px solid #555;
            text-align: center;
            box-sizing: border-box;
        }
    }

    .teacherCanvas {
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
        canvas {
            background: #fff;
        }
        z-index: 10;
        position: absolute;
        left: 120px;
        top: 0px;
        overflow: auto;
    }

    .mainCanvas {
        position: absolute;
        left: 120px;
        top: 100px;
    }

    .cacheCanvas {
        width: 120px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        background: #fff;
        z-index: 1;
    }

    .auxiliary {
        position: absolute;
        left: 120px;
        top: 100px;
    }

    .subjectcontent {
        position: relative;
        float: left;
        margin: 0 2px;
    }

    .scell {
        z-index: 1;
        display: table;
        cursor: pointer !important;
        position: absolute;
        background: transparent;
        color: #555;
        width: 102px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
        .scellContent {
            position: absolute;
            width: 100%;
            font-size: 12px;
            font-family: 'Microsoft Yahei UI';
            z-index: 0;
            pointer-events: none;
        }
    }

    .scell span {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        font-size: 12px;
        line-height: 15px;
        font-weight: 400;
        font-family: 'Microsoft Yahei UI';
        position: relative;

    }

    .studentCell {
        display: table;
        position: absolute;
        background: transparent;
        color: #555;
        z-index: 1200;
        width: 44px;
        height: 20px;
        border: 2px solid rgb(141, 193, 245);
        border-radius: 2px;
    }

    .timeCell {
        color: red;
        width: 50px;
        height: 20px;
        z-index: 1;
        display: table;
        cursor: pointer !important;
        position: absolute;
        background: transparent;
        pointer-events: none;
    }

    .dragging {
        cursor: pointer !important;
    }

    .tableCanvas {
        &::-webkit-scrollbar {
            width:  5px;
            height: 5px;
        }
        position: absolute;
        overflow: scroll;
    }
</style>
